import Vue from 'vue'
import Vuex from 'vuex'

import base from './modules/base' //用户
import user from './modules/user' //用户

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user,
        base,
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js